import { styled } from 'solid-styled-components';

export const StyledResetPassword = styled.div`
    max-width: 480px;
    margin: 0 auto;
`;
